import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/addRow/translation.createTypeValue.mutation.gql"
import type {
  TranslationCreateTypeValueMutation,
  TranslationCreateTypeValueMutationVariables,
} from "@/v2-backoffice-client/translation/addRow/__types__/translation.createTypeValue.mutation"

type Options = MutationHookOptions<
  TranslationCreateTypeValueMutation,
  TranslationCreateTypeValueMutationVariables
>

export function useTranslationCreateTypeValueMutation(options?: Options) {
  return useMutation<
    TranslationCreateTypeValueMutation,
    TranslationCreateTypeValueMutationVariables
  >(mutation, options)
}
